// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/bundle." + {"4":"ab190ce03a8be08a71f9","397":"dce5e281bb7befe793bc"}[chunkId] + ".min.js";
};